import type { FC } from 'react'
import { useMemo } from 'react'
import styled from '@emotion/styled'
import type { Document } from '@contentful/rich-text-types'
import { BLOCKS, MARKS } from '@contentful/rich-text-types'
import type { Options as RichTextRenderOptions } from '@contentful/rich-text-react-renderer'

import Typography from '@segment/matcha/components/Typography'

import RichText from '@segment/matcha/recipes/RichText'

import type { TableOfContentState } from '@segment/utils/useRichTextTableOfContent'

import type { WithoutMethodsDeep } from '@segment/utils/types'

interface ContentSectionProps {
  data: WithoutMethodsDeep<Document>
  tableOfContentState: TableOfContentState
}
const Content: FC<ContentSectionProps> = ({ data, tableOfContentState }) => {
  const options = useMemo<RichTextRenderOptions>(
    () => ({
      renderMark: {
        [MARKS.BOLD]: (text) => <Bold>{text}</Bold>,
      },
      renderNode: {
        [BLOCKS.HEADING_2](node, children) {
          const id = tableOfContentState.getId(node)
          return (
            <Typography variant="h2" tag="h2" id={id}>
              {children}
            </Typography>
          )
        },
      },
    }),
    [tableOfContentState]
  )

  return <RichText data={data} options={options} />
}

export default Content

const Bold = styled.b`
  font-weight: 600;
`
